export default __webpack_public_path__ + "static/media/imagePrintContentFive.7d231e54.png";